import '@fancyapps/fancybox/dist/jquery.fancybox.min';
//import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tooltip';
import Modernizr from 'modernizr';
import LazyLoad from "vanilla-lazyload";


export default class Utils {
    constructor()
    {
        // Utils.disable_right_click();
        Utils.click();
        Utils.bootstrap();
        Utils.fancybox();
        Utils.searchbox();
        Utils.smooth_scroll();
        Utils.lazy();
        Utils.block_cover();
        Utils.obfuscation();
        Utils.progress_bar();
        Utils.replace_broken_image();
    }
    
    static disable_right_click() {
        $(document).on({
            "contextmenu": function (e) {
                e.preventDefault();
            }
        });
    }

    static click()
    {

        const trigger = '[data-trigger="wpiris-click"]';

        if (!Modernizr.touchevents) {
            let ctrl = 0;
            $(window).on('keydown', function (e) {
                if (e.which == 17 || e.which == 91) {
                    ctrl = true
                }
            })
            $(window).on('keyup', function () {
                ctrl = false
            })

            $(document).on('mouseup', trigger, function (e) {

                if (e.target.tagName.toLowerCase() !== 'a') {
                    if (e.which == 1 || e.which == 2) {
                        let blank = false
                        let url = $(this).find("a").attr("href")
                        if (e.which == 2) {
                            blank = true
                        } // Clic molette
                        if ($(this).find("a").attr("target") == "_blank") {
                            blank = true
                        }
                        if (blank || ctrl) {
                            window.open(url, '_blank')
                        } else {
                            window.location = url
                        }
                        return false
                    }
                }
                return false

            })
        } else {
            $(document).on('click', trigger, function (e) {

                let blank = false
                let url = $(this).find("a").attr("href")
                if ($(this).find("a").attr("target") == "_blank") {
                    blank = true
                }
                if (blank) {
                    window.open(url, '_blank')
                } else {
                    window.location = url
                }
                return false

            })
        }
    }
    
    static bootstrap()
    {
        if ( !Modernizr.touchevents ) {
            $( '[data-toggle="tooltip"]' ).tooltip( { trigger: "hover" } )
        }

        $( '[data-toggle="popover"]' ).popover();
    }
    
    static fancybox()
    {

        $( '.hentry a:has(>img):not([target="_blank"]):not("[nofancybox]")' ).attr( 'data-fancybox', 'fancybox' );

        let counter = 0;
        $( '.hentry .wp-block-gallery' ).each( function () {
            counter++;
            $( this ).find( 'a:has(>img)' ).attr( 'data-fancybox', 'wp-block-gallery-' + counter );
        } );

        counter = 0;
        $( '.hentry .wp-block-image' ).each( function () {
            counter++;
            $( this ).find( 'a:has(>img)' ).attr( 'data-fancybox', 'wp-block-image-' + counter );
        } );

        $( '[data-fancybox]' ).fancybox( {
            buttons: [
                "zoom",
                "slideShow",
                "close"
            ],
            lang: "fr",
            backFocus: false,
            i18n: {
                fr: {
                    CLOSE: Theme.translate.fancybox_close,
                    NEXT: Theme.translate.fancybox_next,
                    PREV: Theme.translate.fancybox_prev,
                    ERROR: Theme.translate.fancybox_error,
                    PLAY_START: Theme.translate.fancybox_start,
                    PLAY_STOP: Theme.translate.fancybox_stop,
                    FULL_SCREEN: Theme.translate.fancybox_full_screen,
                    THUMBS: Theme.translate.fancybox_thumbs,
                    DOWNLOAD: Theme.translate.fancybox_download,
                    SHARE: Theme.translate.fancybox_share,
                    ZOOM: Theme.translate.fancybox_zoom
                },
            },
            caption: function ( instance, item ) {
                let caption = $( this ).closest( 'figure' ).find( 'figcaption' ).html();

                if ( !caption ) {
                    caption = $( this ).find( 'img' ).attr( 'title' );
                }

                if ( !caption ) {
                    caption = $( this ).find( 'img' ).attr( 'alt' );
                }

                return caption;
            }
        } );
    }

    static searchbox()
    {
        const trigger  = '[data-trigger="wpiris-search-layout"]',
              close    = '[data-trigger="wpiris-search-layout-close"]',
              $element = $('[data-id="wpiris-search-layout"]');
        
        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            $element.fadeIn().find('input').focus();
        } )
        
        $( document ).on( 'click', close, function ( e ) {
            e.preventDefault();
            $element.fadeOut();
        } )
    }
    
    static smooth_scroll()
    {
        const trigger = '[data-trigger="wpiris-scroll"]';

        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();

            const target = $(this).attr("href") != '' ? $(this).attr("href") : $(this).attr("data-href"),
                duration = 1000,
                scroll_top = $( target ).offset().top - ( undefined !== e.currentTarget.dataset.shift ? e.currentTarget.dataset.shift : 0 );

            $( 'html, body' ).animate( {
                scrollTop: scroll_top
            }, {
                duration: duration,
                step: ( now, fx ) => {
                    let real_pos = scroll_top;
                    if ( fx.end !== real_pos ) {
                        fx.end = real_pos;
                    }
                }
            });
        })
    }
    
    static lazy()
    {
        const lazyLoadInstance = new LazyLoad({
            elements_selector: '[data-src], [data-bg], [data-bg-hidpi]'
        });
        window.onbeforeprint = function () {
            lazyLoadInstance.loadAll();
        };
    }

    static block_cover() {
        $( '.wp-block-cover:has(.wp-block-cover__inner-container a)' ).attr( 'data-trigger', 'wpiris-click' )
    }
    
    static obfuscation()
    {
        let element = "[data-obf]";
        if ( $( element ).length > 0 ) {
            if ( !Modernizr.touchevents ) {
                let ctrl = 0;
                $( window ).on( 'keydown', function ( e ) {
                    if ( e.which == 17 || e.which == 91 ) {
                        ctrl = true;
                    }
                } );
                $( window ).on( 'keyup', function () {
                    ctrl = false;
                } );
                
                $( document ).on( 'mouseup', element, function ( e ) {
                    let url    = atob( $( this ).attr( 'data-obf' ) );
                    let target = $( this ).attr( 'data-obf-target' );
                    if ( e.which == 1 || e.which == 2 ) {
                        let blank = false;
                        if ( e.which == 2 ) {
                            blank = true;
                        } // Clic molette
                        if ( target == "_blank" ) {
                            blank = true;
                        }
                        if ( blank || ctrl ) {
                            window.open( url, '_blank' );
                        } else {
                            window.location = url;
                        }
                        return false;
                    }
                    
                    return false;
                    
                } );
            } else {
                $( document ).on( 'click', element, function ( e ) {
                    let blank  = false;
                    let url    = atob( $( this ).attr( 'data-obf' ) );
                    let target = $( this ).attr( 'data-obf-target' );
                    if ( target == "_blank" ) {
                        blank = true;
                    }
                    if ( blank ) {
                        window.open( url, '_blank' );
                    } else {
                        window.location = url;
                    }
                    return false;
                } );
            }
        }
    }

    static progress_bar()
    {
        $( window ).scroll( function () {
            let s              = $( window ).scrollTop(),
                h              = $( document ).height(),
                c              = $( window ).outerHeight(),
                scroll_percent = (s / (h - c)) * 100;

            const $element = $( '[data-trigger="wpiris-progressbar"]' );

            $element.attr( 'value', scroll_percent );
            $element.css( { 'width': scroll_percent + '%' } );
        } );
    }

    static replace_broken_image()
    {
        // For local environment only
        if ( window.location.hostname.match( /.iris.io/ ) ) {
            let preprod_url = 'https://creilsudoise.preprod5.irislab.top';
            $( 'img' ).on( 'error', function ( e ) {
                let src     = $( this ).attr( 'src' );
                let new_src = src.replace( Theme.server_url, preprod_url );
                $( this ).attr( 'src', new_src );
            } );
        }
    }
}
